import React from 'react';

import { useRequiredParams } from 'utils';
import { HorizontalLayout, IconArrowRight, Text, Title, VerticalLayout } from 'widgets';

import { useAdminPasswordReset } from '../person-queries';

export const ResetPassword = () => {
    const { personOrgGUID } = useRequiredParams(['personOrgGUID']);
    const { mutate: requestPasswordReset } = useAdminPasswordReset(personOrgGUID);

    return (
        <VerticalLayout $gap={32}>
            <Title content>Reset Password</Title>
            <VerticalLayout $gap={16}>
                <Text>Reset person&apos;s password by emailing a reset password link.</Text>
                <Text onClick={() => requestPasswordReset()}>
                    <HorizontalLayout $rowCenter $gap={4}>
                        Send reset password link
                        <IconArrowRight size="micro" />
                    </HorizontalLayout>
                </Text>
            </VerticalLayout>
        </VerticalLayout>
    );
};
